import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { Button } from '../ui/Button';

// Importação do Swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';

// Importação dos estilos do Swiper
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Importação das suas imagens
import imgFundo01 from '../../../src/assets/images/banner_inicial_01.webp';
import imgFundo02 from '../../../src/assets/images/seguranca.webp';
import imgFundo03 from '../../../src/assets/images/paisagismo.webp';
import imgFundo04 from '../../../src/assets/images/limpeza.webp';

export const Hero = () => {
  const slides = [
    {
      id: 1,
      image: imgFundo01,
      tag: "Serviço de Limpeza para Empresas e Condomínios RJ",
      title: "Cuidado Premium para o seu Patrimônio.",
      highlight: "Tranquilidade",
      description: "Há 11 anos transformando ambientes com excelência em Paisagismo, Limpeza e Portaria no Rio de Janeiro."
    },
    {
      id: 2,
      image: imgFundo04,
      tag: "Limpeza e Conservação",
      title: "Ambientes Impecáveis e Higienizados.",
      highlight: "Saúde",
      description: "Equipes treinadas e supervisão constante para garantir o melhor padrão de limpeza."
    },
    {
      id: 3,
      image: imgFundo03,
      tag: "Paisagismo Profissional",
      title: "A Natureza Valorizando seu Espaço.",
      highlight: "Estética",
      description: "Projetos de manutenção de jardins que trazem vida e valorização para o seu imóvel."
    },
    {
      id: 4,
      image: imgFundo02,
      tag: "Portaria e Recepção",
      title: "Segurança e Cordialidade na Entrada.",
      highlight: "Proteção",
      description: "Controle de acesso rigoroso com atendimento humanizado e profissional."
    }
  ];

  return (
    <section id="início" className="relative h-screen w-full overflow-hidden bg-black ">
      <Swiper
        modules={[Autoplay, EffectFade, Pagination, Navigation]}
        effect="fade"
        fadeEffect={{ crossFade: true }}
        speed={1000}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        loop={true}
        className="h-full w-full"
      >
        {/* Adicionamos o 'index' como segundo parâmetro do map */}
        {slides.map((slide, index) => {
          
          // Lógica de SEO: Apenas o primeiro slide (índice 0) será H1. Os demais serão H2.
          const TitleTag = index === 0 ? 'h1' : 'h2';

          return (
            <SwiperSlide key={slide.id} className="relative h-full w-full flex items-center overflow-hidden md:p-20 ">
              
              <div className="absolute inset-0 z-0 bg-emerald-950"> 
                <img 
                  src={slide.image}
                  alt={slide.title} 
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-emerald-950/70 md:bg-emerald-950/70" />
              </div>

              <div className="relative z-10 max-w-7xl mx-auto px-6  w-full ">
                <motion.div 
                  key={slide.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.3 }}
                  className="max-w-3xl"
                >
                  {/* Removemos a classe 'mt-60' daqui para evitar o corte do botão em telas de notebook */}
                  <span className="text-amber-500 font-bold tracking-[0.2em] text-sm mb-4 block uppercase pt-10 md:pt-0">
                    {slide.tag}
                  </span>
                  
                  {/* Utilizamos a TitleTag criada acima. O visual será idêntico para H1 ou H2 graças às classes do Tailwind */}
                  <TitleTag className="text-5xl md:text-7xl font-bold text-white mb-6 leading-[1.1]">
                    {slide.title} <br/>
                    <span className="text-amber-500">{slide.highlight}</span> 
                  </TitleTag>
                  
                  <p className="text-xl text-emerald-50/80 mb-10 leading-relaxed max-w-2xl">
                    {slide.description}
                  </p>
                  
                  <a href='https://wa.me/5521995485623' target='_blank' rel="noreferrer">
                    <Button variant="primary" className="text-lg px-8 py-6 h-auto">
                      <MessageCircle className="fill-current" /> Orçamento Rápido
                    </Button>
                  </a>
                </motion.div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>

      <style dangerouslySetInnerHTML={{ __html: `
        .swiper-pagination-bullet { background: white !important; }
        .swiper-pagination-bullet-active { background: #f59e0b !important; }
      `}} />
    </section>
  );
};